import { render } from "./PricingArea.vue?vue&type=template&id=e7e368f2"
import script from "./PricingArea.vue?vue&type=script&lang=js"
export * from "./PricingArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__